"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "Tất cả khóa học",
    "className": "Tên hội thảo",
    "continue": "Tiếp tục",
    "courseChapter": "Chương",
    "courseEvaluate": "Đánh giá",
    "courseHours": "Số giờ học",
    "courseInfo": "Chi tiết",
    "courseNote": "Ghi chú",
    "coursesCategory": "Danh mục khóa học",
    "electiveCourses": "Khóa học tùy chọn",
    "pages": "Trang",
    "relatedCourses": "Các khóa học liên quan",
    "requiredCourses": "Bài học",
    "searchTips": "Vui lòng nhập Tên khóa học",
    "studentsNum": "Đối tượng",
    "teachersDesc": "Giảng viên",
    "newCourse": "Các khóa học mới nhất"
  },
  "footer_zlb": {
    "aboutUs": "Giới thiệu về Chúng tôi",
    "downLoad": "Tải xuống ỨNG DỤNG",
    "qr": "Mã QR"
  },
  "global_zlb": {
    "am": "Sáng",
    "isa": "　",
    "night": "Chiều/Tối",
    "pm": "CHIỀU/TỐI"
  },
  "header_zlb": {
    "accoutPw": "Mật khẩu tài khoản",
    "curDis": "Đang diễn ra",
    "curUser": "Người dùng hiện tại",
    "edit": "Cập nhật",
    "helpCenter": "Trung tâm trợ giúp",
    "hisDis": "Lịch sử",
    "index": "Trang chủ",
    "joinStore": "Thêm vào mục yêu thích",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Tin nhắn",
    "setIndex": "Đặt làm trang chủ",
    "userImg": "Ảnh đại diện"
  },
  "index_zlb": {
    "discuss": "Hội thảo",
    "find": "Khám phá",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Tôi"
  },
  "info_zlb": {
    "admin": "Quản trị viên",
    "hasAgenda": "Bạn đã tham gia Chương trình học.",
    "noDown": "Không có tệp đính kèm để tải xuống!",
    "pleaseInp": "Vui lòng nhập",
    "submit": "Đã gửi thành công!",
    "withinTime": "Bài tập chưa bắt đầu",
    "noSubmitWork": "Bài tập chưa được gửi"
  },
  "login_zlb": {
    "accountLogin": "Đăng nhập",
    "accountNotEmpty": "Phải điền tài khoản",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Huỷ",
    "captchaNotEmpty": "Phải điền mã xác minh",
    "captchaTips": "Mã xác minh không chính xác",
    "changeEmail": "Cập nhật email",
    "changeEmailSuccess": "Đã cập nhật địa chỉ email thành công.",
    "changeEmailSuccessTips": "Bạn đã cập nhật email thành công.",
    "Confirm": "Xác nhận",
    "currentEmail": "Email hiện tại",
    "emailCaptcha": "Mã xác minh email",
    "emailCaptchaEmpty": "Không được để trống mã xác minh email",
    "encryEmail": "Email bảo mật",
    "error": "Lỗi mã xác minh",
    "forget": "Quên mật khẩu",
    "formerEamil": "Email gốc",
    "incorrectTips": "Lỗi nhập tên người dùng hoặc mật khẩu",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "Email mới",
    "newEmailBinded": "Email mới được liên kết với tài khoản người dùng của bạn",
    "newEmailEmpty": "Không được để trống email mới",
    "newEmailFomat": "Định dạng email mới không chính xác",
    "newEmailSupport": "Địa chỉ email cũ và mới không khớp",
    "prevStep": "Bước cuối",
    "nextStep": "Bước tiếp theo",
    "reset": "Đặt lại",
    "loginNow": "Đăng nhập ngay",
    "resetSuccess": "Đặt lại thành công",
    "resetSuccessTips": "Bạn đã đặt lại mật khẩu thành công. Vui lòng đăng nhập",
    "msgCaptcha": "Mã xác minh SMS",
    "getCaptcha": "Lấy mã xác minh",
    "resetPassword": "Đặt lại mật khẩu",
    "loginFail": "Đăng nhập không thành công. Xin hãy thử lại!",
    "failTips": "Xác minh chưa hoàn thành",
    "inputUserName": "Tên tài khoản",
    "goHome": "Về trang chủ",
    "passwordFormat": "Mật khẩu phải có 8-32 chữ số và gồm số, chữ hoa và chữ thường.",
    "surePasswordEmpty": "Xác nhận mật khẩu không được để trống",
    "confirmNot": "Mật khẩu và mật khẩu xác nhận không giống nhau",
    "changePasswordSuccess": "Đã cập nhật mật khẩu thành công",
    "continueLogin": "Đăng nhập lại",
    "orError": "Tên đăng nhập hoặc mật khẩu không chính xác",
    "orgEmailEmpty": "Email ban đầu không được để trống",
    "orgEmailFormat": "Định dạng email ban đầu không đúng",
    "orgEmailNot": "Địa chỉ email ban đầu không đúng",
    "passWord": "Mật khẩu",
    "surePassword": "Xác nhận mật khẩu",
    "passwordBits": "Mật khẩu phải có ít nhất 6 ký tự",
    "passwordNotEmpty": "Phải điền mật khẩu",
    "pWord": "Mật khẩu",
    "sign": "Đăng nhập",
    "uName": "Tài khoản",
    "userName": "Tên tài khoản",
    "validate": "Mã xác minh",
    "verification": "Vui lòng hoàn thành phần xác minh bên dưới",
    "appdownload": "Tải xuống ứng dụng",
    "scancode": "Quét mã QR để tải xuống",
    "poor": "Yếu",
    "middle": "Trung bình",
    "strong": "Mạnh"
  },
  "login": {
    "logout": "Đăng xuất thành công",
    "resetLoginTips": "Bạn đã đổi mật khẩu thành công, bạn cần đăng nhập lại và để tự động đăng xuất sau 3 giây",
    "sure": "Xác nhận",
    "cancel": "Huỷ",
    "captchaNotEmpty": "Phải điền mã xác minh",
    "accountNotEmpty": "Phải điền tài khoản",
    "passwordNotEmpty": "Phải điền mật khẩu",
    "inputCaptcha": "Mã xác minh",
    "getCaptcha": "Lấy mã xác minh",
    "inputOrigPassword": "Vui lòng nhập mật khẩu ban đầu",
    "inputNewPassowrd": "Vui lòng nhập mật khẩu mới",
    "confimPassword": "Xác nhận mật khẩu",
    "changePassword": "Đổi mật khẩu",
    "nextStep": "Bước tiếp theo",
    "resetPassword": "Đặt lại mật khẩu",
    "resetDone": "Đặt lại mật khẩu thành công",
    "msgCaptcha": "Mã xác minh email"
  },
  "look_zlb": {
    "aboutLecturer": "Các khóa học liên quan",
    "benginLearn": "Bắt đầu học",
    "chapter": "Chương",
    "delete": "Xóa",
    "details": "Chi tiết",
    "download": "Tải xuống",
    "dynamic": "Tin tức",
    "evaluation": "Đánh giá",
    "hotDyc": "Đang thịnh hành",
    "lecture": "Mở khóa học",
    "lecturer": "Giảng viên",
    "lectureTest": "Danh mục khóa học",
    "look": "Khám phá",
    "lookAll": "Xem tất cả",
    "note": "Ghi chú",
    "score": "Điểm"
  },
  "myMessage_zlb": {
    "passwordError": "Lỗi nhập mật khẩu ban đầu",
    "aboutUs": "Giới thiệu về Chúng tôi",
    "allcourse": "Tất cả khóa học",
    "atypism": "Hai mật khẩu không khớp",
    "birth": "Ngày sinh",
    "cancel": "Huỷ",
    "carryOut": "Hoàn thành",
    "changePassword": "Đổi mật khẩu",
    "chineseName": "Tên tiếng Trung",
    "chineseNamePlaceholder": "Vui lòng nhập tên tiếng Trung",
    "code": "Mã xác minh",
    "codeError": "Lỗi mã xác minh",
    "comment": "Bình luận",
    "complete": "Hoàn thành",
    "completeUserInfo": "Vui lòng điền đầy đủ thông tin cá nhân",
    "confirm": "Xác nhận mật khẩu",
    "continueStudy": "Tiếp tục",
    "country": "Quốc gia",
    "countryName": "Tên",
    "countryNamePlaceholder": "Vui lòng nhập tên bạn",
    "countryPlaceholder": "Vui lòng chọn quốc gia",
    "courseLearned": "Đã hoàn thành",
    "delete": "Xóa",
    "documentType": "Loại giấy tờ tùy thân",
    "downloaded": "Đã tải xuống",
    "downloading": "Đang tải xuống",
    "eduLevel": "Trình độ học vấn",
    "eduLevelPlaceholder": "Vui lòng chọn trình độ học vấn",
    "email": "Email",
    "emailCode": "Mã xác minh email",
    "gender": "Giới tính",
    "genderPlaceholder": "Vui lòng chọn giới tính",
    "getCode": "Nhận mã xác minh email",
    "hasSent": "Đã gửi",
    "helpCenter": "Trung tâm trợ giúp",
    "hour": "Giờ",
    "improveInformation": "Vui lòng điền đầy đủ thông tin cá nhân",
    "joinClasses": "Khóa học đã tham dự",
    "joinDis": "Hội thảo đã tham dự",
    "learned": "Đã kết thúc",
    "learning": "Đang diễn ra ",
    "lecture": "Khóa học",
    "mailbox": "Email",
    "mailboxValidate": "Xác minh email không thành công",
    "man": "Nam",
    "management": "Cài đặt",
    "minutes": "x giờ x phút",
    "modify": "Cập nhật",
    "modifyEmail": "Cập nhật email",
    "my": "Tôi",
    "myCertificate": "Chứng chỉ của tôi",
    "mycourse": "Khóa học của tôi",
    "myDownload": "Nội dung tải xuống của tôi",
    "myLecture": "Khóa học của tôi",
    "myNotes": "Ghi chú của tôi",
    "newMail": "Email mới",
    "newPassword": "Mật khẩu mới",
    "nextStep": "Bước tiếp theo",
    "orError": "Tên đăng nhập hoặc mật khẩu không chính xác",
    "origin": "Từ",
    "originalPassword": "Mật khẩu ban đầu",
    "password": "Mật khẩu",
    "phone": "Số điện thoại",
    "pleChoose": "Vui lòng chọn ngày sinh",
    "post": "Bài đăng",
    "postPlaceholder": "Vui lòng nhập bài đăng",
    "religion": "Tôn giáo",
    "religionPlaceholder": "Vui lòng chọn tôn giáo",
    "retrievePassword": "Lấy lại mật khẩu",
    "setUp": "Cài đặt",
    "signOut": "Đăng xuất",
    "something": "Tôi muốn nói",
    "submit": "Gửi",
    "sureDelte": "Bạn có chắc chắn muốn xóa không?",
    "teacher": "Giảng viên",
    "learnYet": "Chưa bắt đầu học",
    "uName": "Tên tài khoản",
    "uNamePlaceholder": "Tên tài khoản",
    "userCenter": "Thông tin cá nhân ",
    "username": "Tên tài khoản",
    "validateMsg": "Xác minh chưa hoàn thành",
    "woman": "Nữ",
    "learnTo": "Tiến trình",
    "myRecord": "Hồ sơ của tôi",
    "plePhone": "Vui lòng nhập số điện thoại"
  },
  "notice_zlb": {
    "delete": "Xóa",
    "home": "Trang chủ",
    "lettre": "Tin nhắn cá nhân",
    "lettreEmpty": "Tin nhắn cá nhân không được để trống",
    "messageDetail": "Nội dung tin nhắn",
    "myMessage": "Tin nhắn của tôi",
    "notice": "Thông báo",
    "nowBavarder": "Giờ đây bạn có thể bắt đầu trò chuyện",
    "send": "Gửi"
  },
  "play_zlb": {
    "networkTip": "Thông báo mạng",
    "streamHighTip": "Kết nối mạng hiện tại ổn định. Chúng tôi đã chuyển sang chế độ độ nét cao cho bạn.",
    "streamHighType": "HD",
    "streamNormTip": "Kết nối mạng hiện tại không ổn định. Chúng tôi đã chuyển sang chế độ độ nét tiêu chuẩn cho bạn.",
    "streamNormType": "SD",
    "liveTimeDes": "Thời gian trực tiếp",
    "livePlayWait": "Bài học trực tiếp chưa bắt đầu",
    "livePlayEnd": "Bài học trực tiếp đã kết thúc"
  },
  "questionnaire_zlb": {
    "handed": "Gửi",
    "saveFailed": "Lưu không thành công",
    "examList": "Danh sách câu hỏi kiểm tra"
  },
  "research_zlb": {
    "afternoon": "CHIỀU/TỐI",
    "all": "Tất cả",
    "allCalendar": "Tất cả chương trình học",
    "alumniBook": "Thành viên",
    "broadcast": "x bắt đầu truyền phát",
    "carriedout": "Trong tiến trình",
    "certificate": "Chứng chỉ",
    "comment": "Bình luận",
    "comments": "Tất cả x bình luận",
    "courses": "Tài liệu tham khảo",
    "curDis": "Đang diễn ra",
    "default": "Chưa bắt đầu",
    "delete": "Xóa",
    "detail": "Chi tiết",
    "discuss": "Diễn đàn",
    "end": "Đã kết thúc",
    "endAssess": "Bài đánh giá kết thúc",
    "enterAssess": "Bắt đầu làm bài đánh giá",
    "assessButton": "Phản hồi",
    "evaluation": "Đánh giá",
    "fileAcept": "Loại tệp sai, Vui lòng tải lên lại.",
    "fileSize10": "Tệp đã chọn quá 10m, vui lòng tải lên lại.",
    "hisDis": "Lịch sử",
    "lecture": "Tài liệu tham khảo",
    "live": "Trực tiếp",
    "livebroadcast": "Phát trực tiếp",
    "minutes": "x phút trước",
    "month": "Tháng",
    "morning": "Sáng",
    "noDiscussion": "Không có hội thảo",
    "noSchedule": "Không có chương trình học",
    "notice": "Thông báo",
    "notification": "Thông báo chưa đọc",
    "offline": "Bài giảng trực tiếp",
    "onging": "Trong tiến trình",
    "online": "Trực tuyến",
    "operation": "Bài tập",
    "over": "Đã kết thúc",
    "participated": "Đã tham gia ",
    "notParticipate": "Chưa tham gia ",
    "failedCourse": "Không đạt",
    "passedCourse": "Đạt",
    "preparation": "Chuẩn bị bài tập",
    "preparations": "Chuẩn bị bài tập",
    "preschoolLecture": "Bài giảng mở đầu",
    "questionnaire": "Bảng câu hỏi",
    "questionType ": "trắc nghiệm (chỉ một câu trả lời đúng; gạch bỏ tất cả câu trả lời sai)",
    "readySay": "Tôi muốn nói",
    "replies": "Bạn có x trả lời mới",
    "save": "Lưu",
    "schedule": "Nội dung học",
    "searchC": "Tìm kiếm chủ đề bạn quan tâm",
    "seeAssess": "Xem bài đánh giá",
    "submit": "Gửi",
    "submitHomewor": "Huỷ",
    "task": "Bài tập",
    "taskToday": "Bài tập của hôm nay",
    "video": "Video",
    "week": "Tuần",
    "yourcomment": "Viết ra bình luận của bạn",
    "legend": "Chú thích",
    "sunday": "Chủ Nhật",
    "monday": "Thứ Hai",
    "tuesday": "Thứ Ba",
    "wednesday": "Thứ Tư",
    "thursday": "Thứ Năm",
    "friday": "Thứ Sáu",
    "saturday": "Thứ Bảy",
    "consult": "Tài liệu tham khảo",
    "schedules": "Bài tập",
    "calendar": "Lịch",
    "waitAssesment": "Bảng câu hỏi cần gửi",
    "year": "Năm",
    "day": "Ngày",
    "preview": "Xem trước",
    "resource": "Tải xuống"
  },
  "retrieve_zlb": {
    "emailEmpty": "Địa chỉ email không được để trống.",
    "emailVerif": "Xác thực email"
  },
  "task_zlb": {
    "downF": "Tải xuống tài liệu đính kèm",
    "repeatUp": "Tải lên lại",
    "ruY": "Nếu một tệp đính kèm đã được tải lên ứng dụng, tệp đó sẽ bị ghi đè nếu bạn tải tệp khác lên qua máy tính.",
    "submitC": "Vui lòng nhập nội dung bạn muốn gửi",
    "uploadF": "Tải lên Tài liệu đính kèm"
  },
  "upload_zlb": {
    "clickHere": "bấm vào đây",
    "limit": "Định dạng được hỗ trợ PNG, JPG kích thước không được vượt quá",
    "preview": "Xem trước sau khi tải ảnh lên",
    "upload": "Tải lên"
  },
  "index": {
    "setAsHomePage": "Đặt làm trang chủ",
    "addCollection": "Thêm vào mục yêu thích",
    "telephone": "Đường dây nóng",
    "Help": "Trung tâm trợ giúp",
    "SystemMessage": "Thông báo hệ thống",
    "message": "Tin nhắn cá nhân",
    "emptyMessage": "Xóa",
    "checkAllMessage": "Xem tất cả",
    "noMessage": "Không có dữ liệu",
    "fullScreen": "Hiển thị toàn màn hình",
    "ExitSystem": "Thoát khỏi hệ thống này",
    "back": "Trở lại",
    "top": "Đầu trang",
    "backToTop": "Trở lại đầu trang",
    "homePage": "Trang chủ",
    "favoriteTips": "Do giới hạn của trình duyệt 360/trình duyệt Google, vui lòng nhấn Ctrl + D để cho vào mục yêu thích bằng cách thủ công!",
    "autoSetHomeTips": "Trình duyệt của bạn không hỗ trợ thiết lập trang chủ tự động, vui lòng sử dụng menu trình duyệt để thiết lập thủ công!",
    "currentUser": "Người dùng hiện tại",
    "userHead": "Ảnh đại diện",
    "accountPassword": "Mật khẩu tài khoản",
    "change": "Cập nhật",
    "head": "Ảnh đại diện",
    "continueStudy": "Tiếp tục",
    "startStudy": "Bắt đầu học"
  },
  "course": {
    "count": "Thông tin chung",
    "item": "Bài viết",
    "up": "Trang trước",
    "next": "Trang sau",
    "items": "mỗi trang",
    "go": "Chuyển đến",
    "page": "Trang",
    "man": "Người dùng",
    "score": "Điểm",
    "courseYear": "Năm",
    "courseTeachers": "Giảng viên",
    "noDesc": "Không giới thiệu",
    "teachersDesc": "Hồ sơ giáo viên",
    "checkLog": "Xem hồ sơ",
    "startStudy": "Bắt đầu học",
    "JoinLearning": "Tham gia",
    "isEvaluate": "Đã đánh giá",
    "deleteNoteButton": "Xóa",
    "closeButton": "Đóng",
    "noteSource": "Từ"
  },
  "onlineclass": {
    "myScore": "Điểm số của tôi",
    "comments": "Nhận xét",
    "iknow": "Tôi biết",
    "detail": "Chi tiết",
    "inforCertificate": "Chứng chỉ",
    "wantTalk": "Tôi muốn nhận xét",
    "inputTalkContent": "Vui lòng nhập nhận xét",
    "publish": "Đăng lên",
    "undo": "Huỷ",
    "reply": "Trả lời",
    "delete": "Xóa",
    "Learned": "Đã hoàn thành",
    "isDelete": "Bạn có chắc chắn muốn xóa không?",
    "submitTime": "Thời gian gửi",
    "to": "đến",
    "download": "Tải xuống"
  },
  "usercenter": {
    "htllo": "Xin chào",
    "welcomeMessage": "Chúc bạn một ngày tốt lành",
    "searchTips": "Tìm kiếm khóa học bạn thích",
    "myCertificate": "Chứng chỉ của tôi",
    "startQuestionnaire": "Bắt đầu trả lời bài",
    "empty": "không có gì",
    "confirmDelete": "Xác nhận xóa",
    "confirmDeleteTips": "Bạn có chắc chắn muốn xóa không?",
    "delete": "Xóa",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "Kết thúc học",
    "tips": "Chỉ dẫn",
    "playTips": "Chỉ dẫn: Vui lòng nhấp vào nút \"Kết thúc học\" ở góc trên cùng bên phải để thoát. Nếu bạn thoát bài học bằng cách đóng trình duyệt, thời gian học của bạn có thể không được ghi lại chính xác.",
    "notShowAgain": "Không nhắc tôi lại",
    "gotIt": "Tôi biết",
    "chapter": "Chương",
    "language": "Ngôn ngữ",
    "chapterText1": "Không.",
    "chapterText2": "Chương",
    "note": "Ghi chú",
    "noteBlockTitle": "Ghi chú",
    "evaluate": "Đánh giá",
    "evaluateStar": "Sao",
    "saveEvaluate": "Gửi",
    "notePlaceholder": "Vui lòng ghi chú lại",
    "closeTips": "Các thay đổi của bạn có thể không được lưu",
    "closeButton": "Thoát",
    "autoStop": "Tự động dừng phát",
    "autoStopTips": "Hết thời gian do người dùng không có hoạt động. Tự động dừng phát.",
    "confirmOut": "Bạn có chắc chắn muốn dừng phát không?",
    "closeOrNot": "Đóng cửa sổ hiện tại",
    "noCoursePlay": "Không tìm thấy nguồn có thể phát trong khóa học hiện tại",
    "attention": "Xin hãy chú ý!"
  },
  "assessment_zlb": {
    "score": "Điểm",
    "evalSuccess": "Đánh giá thành công"
  },
  "undefined": {}
};